export default {
  cancel: 'Cancelar',
  circle_config: 'Configuración del círculo',
  confirm: 'Confirmar',
  confirm_delete: '¿Estas seguro que quieres borrarlo? No se puede deshacer.',
  create: 'Crear',
  delete_geometry: 'Eliminar geometría',
  delete_vertex: 'Eliminar vértice',
  document_upload_failed: 'Error al cargar el documento.',
  draw_circle: 'Círculo desde el centro',
  draw_circle_2pt: 'Círculo manual',
  draw_dialog_begin_drawing:
    'Comenzar a dibujar - Haz clic en cualquier lugar del mapa',
  draw_dialog_cancel_drawing: 'Cancelar dibujo - Tecla ESC',
  draw_dialog_remove_vertex: 'Eliminar último vértice - Clic derecho',
  draw_dialog_save: 'Guardar - Doble clic',
  draw_dialog_save_single: 'Guardar - Clic simple',
  draw_dialog_title: 'Instrucciones de dibujo',
  draw_line: 'Línea',
  draw_point: 'Punto',
  draw_polygon: 'Polígono',
  draw_position: 'Posición actual',
  draw_rectangle: 'Rectángulo',
  edit_dialog_cancel_drawing: 'Cancelar edición - Tecla ESC',
  edit_dialog_modify_shape: 'Modificar forma - Arrastrar vértices',
  edit_dialog_remove_vertex: 'Eliminar vértice - Clic derecho',
  edit_dialog_save: 'Guardar - Doble clic',
  edit_dialog_title: 'Instrucciones de edición',
  filter_searchbox_placeholder: 'Buscar',
  icon_scaling_cluster: 'Escala de icono de grupo',
  icon_scaling_cluster_log: 'Escala de registro de grupo',
  icon_scaling_field: 'Alternar escala de icono de campo',
  icon_scaling_label: 'Escala de icono',
  icon_scaling_zoom_in: 'Escala de zoom',
  icon_scaling_zoom_out: 'Escala de zoom',
  identical_values_filter:
    'Este campo contiene solo un valor distinto y no se puede filtrar.',
  image_upload_failed: 'Error al cargar la imagen.',
  information: 'Información',
  invalid_geometry: 'Geometría no válida',
  invalid_lat_lon:
    'Las coordenadas proporcionadas no caen dentro de la localidad seleccionada.',
  invalid_lat_long_range:
    'Coordenadas no válidas: los valores de latitud y longitud deben estar dentro de rangos válidos.',
  layer_add_new_location: 'Agregar nuevos sitios',
  layer_dataview_header: 'Ver los datos',
  layer_filter_clear_all: 'Anular todos los filtros',
  layer_filter_dropdown_select: 'Seleccionar múltiples',
  layer_filter_greater_than: 'Mas grande que',
  layer_filter_header: 'Filtro',
  layer_filter_less_than: 'Menos que',
  layer_filter_reset_all: 'Restablecer todos los filtros',
  layer_filter_select: 'Seleccionar filtro de la lista',
  layer_filter_set_filter: 'Definir el filtro',
  layer_grid_legend_ratio: 'Mostrar el color como una relación con el tamaño',
  layer_group_hide_layers: 'Ocultar todas las capas del grupo',
  layer_style_cluster: 'Múltiples localizaciones',
  layer_style_display_hover: 'Ver a través del curso',
  layer_style_display_labels: 'Mostrar etiquetas',
  layer_style_header: 'Estilo',
  layer_style_opacity: 'Cambiar opacidad de la capa:',
  layer_style_select_theme: 'Seleccionar estilo temático',
  layer_style_switch_all: 'Cambiar todo',
  layer_style_switch_caption:
    'Clic en las etiquetas para cambiar la visibilidad o',
  layer_visibility: 'Alternar visibilidad',
  layer_zoom_to_extent: 'Zoom a capa filtrada',
  layers: 'Capas',
  link: 'Enlace',
  loading: 'Cargando',
  location_clear_all: 'Borrar localizaciones',
  location_close_without_save: '¿Cerrar sin guardar cambios?',
  location_delete: 'Eliminar ubicación',
  location_listview_full: 'La vista de lista de ubicaciones está llena.',
  location_remove: 'Eliminar de la selección',
  location_save: 'Registrar modificaciones',
  location_save_changes: '¿Guardar los cambios en esta ubicación?',
  location_zoom: 'Ampliar los contornos del objeto.',
  locations: 'Ubicaciones',
  modify_geometry: 'Modificar geometría',
  no_data_filter: 'Este campo no contiene datos y no se puede filtrar.',
  no_layers: 'No hay capas accesibles en la localidad.',
  no_locales:
    'Su cuenta ha sido verificada y aprobada, pero no tiene acceso a ninguna localidad. Esto se debe probablemente a que un administrador no le ha asignado los roles necesarios. Por favor, contacte a un administrador para resolver este problema.',
  no_options_available: 'No hay opciones disponibles.',
  no_results: 'No hay resultados para esta búsqueda',
  ok: 'OK',
  pill_component_remove: 'Eliminar',
  pin: 'Marcar',
  radius: 'Radio',
  remove_document_confirm:
    '¿Estás seguro de que quieres eliminar este documento?',
  remove_image_confirm: '¿Estás seguro de que quieres eliminar esta imagen?',
  remove_item_confirm: '¿Eliminar elemento?',
  remove_last_vertex: 'Eliminar el último vértice',
  report: 'Informe',
  save: 'Salvar',
  toolbar_admin: 'Abrir vista de administrador de cuenta',
  toolbar_current_location: 'Ubicación actual',
  toolbar_fullscreen: 'Vista de mapa en pantalla completa',
  toolbar_login: 'Iniciar sesión',
  toolbar_logout: 'Desconexión',
  toolbar_zoom_in: 'Zoom +',
  toolbar_zoom_out: 'Zoom -',
  toolbar_zoom_to_area: 'Zoom al área',
  units: 'Unidad',
  zoom_to: 'Acercar a',
};
